module.exports = __webpack_public_path__ + "img/coincap-logo.212a1e50.png";